import React from "react";
import CustomerDetail from "../../customers/CustomerDetail";

const BorrowerTab = ({ activeColor = "blue", account, id, defaultTab, shellThemeVariant = "1" }) => {
  return (
    <div className="p-0">
      <CustomerDetail
        id={id}
        activeColor={activeColor}
        account={account}
        defaultTab={defaultTab}
        shellThemeVariant={shellThemeVariant}
        embedded
      />
    </div>
  );
};

export default BorrowerTab;


